import React from "react";

const OrderSummarySection = ({
  getCurrencySymbol,
  subtotal,
  vat,
  minimumOrderAdjustment,
  total,
  requiredMinimum,
  hasShippingDetails,
  displayShipping,   // ✅ single source of truth
}) => {
  const ship = displayShipping || {};

  return (
    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      {/* Subtotal */}
      <div className="col-span-full">
        <label htmlFor="subtotal" className="block text-left text-sm font-medium text-gray-400">
          Subtotal
        </label>
        <input
          type="text"
          name="subtotal"
          id="subtotal"
          value={`${getCurrencySymbol()} ${Number(subtotal || 0).toFixed(2)}`}
          className="mt-2 block w-full border-b border-gray-900/10 text-lg text-gray-900 bg-transparent sm:text-lg"
          readOnly
        />
      </div>

      {/* Shipping Details */}
      <div className="col-span-full">
        <label htmlFor="shipping" className="block text-left text-sm font-medium text-gray-400">
          Shipping
        </label>
        {hasShippingDetails ? (
          <div className="mt-2 space-y-1">
            {ship.country && ship.country !== "0" && (
              <div className="flex justify-between text-sm text-gray-700">
                <span>Country:</span>
                <span>{ship.country}</span>
              </div>
            )}
            {ship.state && ship.state !== "0" && (
              <div className="flex justify-between text-sm text-gray-700">
                <span>State:</span>
                <span>{ship.state}</span>
              </div>
            )}
            {ship.town && ship.town !== "0" && (
              <div className="flex justify-between text-sm text-gray-700">
                <span>Town/City:</span>
                <span>{ship.town}</span>
              </div>
            )}
            {ship.pin_code && ship.pin_code !== "0" && (
              <div className="flex justify-between text-sm text-gray-700">
                <span>PIN Code:</span>
                <span>{ship.pin_code}</span>
              </div>
            )}
          </div>
        ) : (
          <p className="mt-2 text-sm text-left text-gray-600">Shipping details not provided</p>
        )}
      </div>

      {/* Minimum Order Adjustment */}
      {Number(minimumOrderAdjustment) > 0 && (
        <div className="col-span-full">
          <label htmlFor="minimum-order" className="block text-left text-sm font-medium text-gray-400">
            Minimum Order Adjustment
          </label>
          <input
            type="text"
            id="minimum-order"
            value={`${getCurrencySymbol()} ${Number(minimumOrderAdjustment || 0).toFixed(2)}`}
            className="mt-2 block w-full border-b border-gray-900/10 py-1.5 text-lg text-gray-900 bg-transparent"
            readOnly
          />
        </div>
      )}

      {/* VAT */}
      <div className="col-span-full">
        <label htmlFor="vat" className="block text-left text-sm font-medium text-gray-400">
          GST (18%)
        </label>
        <input
          type="text"
          name="vat"
          id="vat"
          value={`${getCurrencySymbol()} ${Number(vat || 0).toFixed(2)}`}
          className="mt-2 block w-full border-b border-gray-900/10 py-1.5 text-lg text-gray-900 bg-transparent"
          readOnly
        />
      </div>

      {/* Total */}
      <div className="col-span-full">
        <label htmlFor="total" className="block text-left text-sm font-medium text-gray-400">
          Total
        </label>
        <input
          type="text"
          name="total"
          id="total"
          value={`${getCurrencySymbol()} ${Number(total || 0).toFixed(2)}`}
          className="mt-2 block w-full py-1.5 text-3xl font-bold text-gray-900 bg-transparent"
          readOnly
        />
      </div>

      {/* Minimum Order Warning */}
      {Number(minimumOrderAdjustment) > 0 && (
        <div className="col-span-full">
          <p className="text-red-600 text-sm font-medium mt-2">
            Minimum order is {getCurrencySymbol()} {Number(requiredMinimum || 0).toFixed(2)}.
          </p>
        </div>
      )}
    </div>
  );
};

export default OrderSummarySection;